import { getUseResource } from '../resource';
import { activityResources } from '../builders/activityResources';
import { IAnalyticsActivity } from '../../models/AnalyticsActivity';

export type AnalyticsActivityType = 'activeNow' | 'activeToday' | 'activeWeek' | 'activeMonth';

export const apiActivity = {
  useGetActivity: getUseResource(
    activityResources.getActivity,
    (body): IAnalyticsActivity[] => body,
    (params, type: AnalyticsActivityType) => ({ type })
  ),
  useGetIpActivity: getUseResource(
    activityResources.getIpActivity,
    (body): IAnalyticsActivity['ip'] => body,
    (params, ip: string) => ({ ip })
  ),
};
